// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"e29136c6","698":"2ea1d54b","818":"93115311"}[chunkId] + ".chunk.js";
};